var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBottomwave = function SvgBottomwave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1920,
    height: 100
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "props.fill",
    d: "m0 35 24.7 5.7c24.6 5.6 74 17 123.1 11.6C197 47 246 25 295.2 20.2c49.1-4.9 98.5 7.5 147.8 16.6C492.3 46 541.7 52 590.8 59.5 640 67 689 76 738.2 79.2c49.1 3.1 98.5.5 147.8-6s98.7-16.9 148-28.4 98.7-24.1 147.8-19.5C1231 30 1280 52 1329.2 55.5c49.1 3.5 98.5-11.5 147.8-11s98.7 16.5 147.8 27.3C1674 82.7 1723 88.3 1772.2 86c49.1-2.3 98.5-12.7 123.1-17.8L1920 63V0H0z"
  })));
};
export default SvgBottomwave;